<template>
  <div class="sidebar-menu">
    <el-menu
      :default-active="activeMenu"
      :collapse="false"
      background-color="#1f2d3d"
      text-color="#fff"
      active-text-color="#409eff"
      :unique-opened="false"
      :collapse-transition="false"
      mode="vertical"
    >
      <template v-for="menu in menus" :key="menu.path">
        <el-sub-menu v-if="menu.children && menu.children.length > 0" :index="menu.path">
          <template #title>
            <SvgIcon v-if="menu.icon" :icon="menu.icon" class="menu-icon" />
            <span>{{ resolveTitle(menu) }}</span>
          </template>
          <el-menu-item
            v-for="child in menu.children"
            :key="`${menu.path}/${child.path}`"
            :index="`${menu.path}/${child.path}`.replace(/\/+/g, '/')"
            @click="handleMenuItemClick(`${menu.path}/${child.path}`.replace(/\/+/g, '/'))"
          >
            <!-- <SvgIcon v-if="child.icon" :icon="child.icon" class="menu-icon" /> -->
            <span>{{ resolveTitle(child) }}</span>
          </el-menu-item>
        </el-sub-menu>
        <el-menu-item v-else :index="menu.path" @click="handleMenuItemClick(menu.path)">
          <SvgIcon v-if="menu.icon" :icon="menu.icon" class="menu-icon" />
          <span>{{ resolveTitle(menu) }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script lang="ts">
import SvgIcon from '@/components/SvgIcon.vue';
import { useAppStore } from '@/stores/app';
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

interface MenuItem {
  title: string;
  titleKey?: string;
  path: string;
  icon?: string;
  children?: MenuItem[];
}

export default defineComponent({
  name: 'SidebarMenu',
  components: {
    SvgIcon,
  },
  setup() {
    const appStore = useAppStore();
    const route = useRoute();
    const router = useRouter();
    const { t } = useI18n();

    const menus = computed(() => appStore.menus);

    const activeMenu = computed(() => {
      const { path } = route;
      return path;
    });

    function resolveTitle(menu: MenuItem) {
      return menu.titleKey ? t(menu.titleKey) : menu.title;
    }

    function handleMenuItemClick(path: string) {
      void router.push(path);
    }

    return {
      menus,
      activeMenu,
      resolveTitle,
      handleMenuItemClick,
    };
  },
});
</script>

<style scoped lang="scss">
.sidebar-menu {
  :deep(.el-menu) {
    border-right: none;
  }

  :deep(.el-sub-menu__title:hover),
  :deep(.el-menu-item:hover) {
    background-color: #273849 !important;
  }

  :deep(.el-menu-item.is-active) {
    background-color: #409eff !important;
    color: white !important;
  }

  .menu-icon {
    margin-right: 8px;
    font-size: 14px;
    color: #fff;
  }
}
</style>
